import React, { useState } from 'react';
import { useI18n } from '@/lib/i18n';
import { formatAirDate, dueByDateTime } from '@/lib/mixDates';
import { formatTime } from '@/lib/schedule';
import { formatDuration } from '@/lib/tracklist';
import UploadForm from './UploadForm';

export default function AirDateCard({ show, airDate, uploads, userEmail, onRefresh, adminOnBehalf = false, actingHostId = null }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const hasUploads = uploads && uploads.length > 0;
  const sorted = [...(uploads || [])].sort((a, b) => (a.part || 0) - (b.part || 0));

  return (
    <div className="bg-white rounded-xl border border-neutral-200 p-4 flex flex-col">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-neutral-400 text-xs font-semibold uppercase tracking-wide">
            {formatAirDate(airDate)}
          </p>
          <p className="text-black font-bold text-sm mt-0.5">
            {formatTime(show.start_time)} ET
          </p>
        </div>
        {hasUploads ? (
          <span className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-green-100 text-green-700 text-xs font-bold">
            {t('Uploaded')}
          </span>
        ) : (
          <span className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-100 text-amber-700 text-xs font-bold text-right">
            {t('Missing')} — {t('due by')} {dueByDateTime(show, airDate)}
          </span>
        )}
      </div>

      {hasUploads && (
        <ul className="mt-3 space-y-1">
          {sorted.map((u) => (
            <li key={u.id} className="text-xs text-neutral-600 flex items-center gap-1.5">
              <span className="font-bold text-neutral-800">{t('Part')} {u.part}:</span>
              <span className="truncate">{u.file_name}</span>
              <span className="text-neutral-400">· {formatDuration(u.duration_seconds)}</span>
              <span className="font-semibold text-neutral-700">· {u.status}</span>
            </li>
          ))}
        </ul>
      )}

      <button
        onClick={() => setOpen(true)}
        className="mt-4 self-start px-4 py-2 rounded-lg bg-purple-700 text-white text-sm font-bold hover:bg-purple-800 transition-colors"
      >
        {t('Upload part')}
      </button>

      {open && (
        <UploadForm
          show={show}
          airDate={airDate}
          existingParts={uploads || []}
          userEmail={userEmail}
          adminOnBehalf={adminOnBehalf}
          actingHostId={actingHostId}
          onClose={() => setOpen(false)}
          onDone={() => {
            setOpen(false);
            onRefresh();
          }}
        />
      )}
    </div>
  );
}